import React, { useEffect, useState } from 'react';
import './App.css';
import Logo from './assets/images/UMASUN_SERVIKARO.png'; // Import logo
import DuttaPhoto from './assets/images/Dutta.jpg'; // Import Dutta's photo
import Sinha from './assets/images/Sinha.jpeg'; // Import Sinha's photo
// Import client logos
import SimectiveLogo from './assets/images/simective.png';
import TataLogo from './assets/images/TataD.png';
import ElectroAssociatesLogo from './assets/images/Electro.png';
import TriozoneLogo from './assets/images/trizone.png';
import NeocellLogo from './assets/images/neocell.png';
// Import service GIFs
import SolarSolutionsGIF from './assets/images/SolarSolutions.gif';
import GeneralConstructionGIF from './assets/images/GeneralConstruction.gif';
import GreenSolutionsGIF from './assets/images/GreenSolutions.gif';
import FurnitureHomeDecorGIF from './assets/images/FurnitureHomeDecor.gif';
import SoftwareDevelopmentGIF from './assets/images/SoftwareDevelopment.gif';
import emailjs from '@emailjs/browser';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const App: React.FC = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // emailjs.send("service_w1tjktd","template_lmbfb19",{
    //   from_name: "Orpita",
    //   to_name: "Shakti",
    //   message: "testtsjknkjk guihgi",
    //   email: "tete@gmail.com",
    //   reply_to: "gyuigi",
    //   });
    // Send email using EmailJS
    emailjs
      .send(
        'service_w1tjktd', // Replace with your EmailJS Service ID
        'template_lmbfb19', // Replace with your EmailJS Template ID
        {
          from_name: formData.name,
          to_name: "UmaSun Servikaro",
          email: formData.email,
          message: formData.message,
          reply_to: ""
        },
        'H2vU8VS1C1Uj7ndBq' // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          alert('Message sent successfully!');
          setFormData({ name: '', email: '', message: '' });
        },
        (error) => {
          alert('Failed to send message. Please try again.');
          console.error('EmailJS error:', error);
        }
      );
  };
  
  useEffect(() => {
    const shapesContainer = document.querySelector('.app');
    const shapesCount = 10;

    for (let i = 0; i < shapesCount; i++) {
      const shape = document.createElement('div');
      shape.classList.add('random-shape');

      const shapeTypes = ['circle', 'triangle', 'square'];
      const randomShape = shapeTypes[Math.floor(Math.random() * shapeTypes.length)];
      shape.classList.add(randomShape);

      const size = Math.random() * 20 + 10;
      shape.style.width = `${size}px`;
      shape.style.height = randomShape === 'triangle' ? '0' : `${size}px`;

      shape.style.left = `${Math.random() * 100}vw`;
      shape.style.top = `${Math.random() * 100}vh`;

      const duration = Math.random() * 20 + 10;
      shape.style.animationDuration = `${duration}s`;

      shape.style.animationDirection = Math.random() > 0.5 ? 'normal' : 'reverse';

      shapesContainer?.appendChild(shape);
    }
  }, []);


  return (
    <HelmetProvider>
      <div className="app">
        {/* Global SEO Metadata */}
        <Helmet>
          <title>UmaSun Servikaro - Solar Energy Solutions & Eco-Friendly Construction in Thane</title>
          <meta
            name="description"
            content="UmaSun Servikaro offers solar energy solutions, eco-friendly construction, sustainable home decor, and IoT software development in Thane, Maharashtra. Contact us for green solutions in India!"
          />
          <meta
            name="keywords"
            content="solar energy solutions, eco-friendly construction, sustainable home decor, green solutions India, IoT software development, solar panel installation Thane, sustainable furniture Maharashtra, UmaSun Servikaro"
          />
          <meta name="author" content="UmaSun Servikaro" />
          <meta name="robots" content="index, follow" />
          <meta name="google-site-verification" content="google05f67a38f089aa14.html" />
          <meta property="og:title" content="UmaSun Servikaro - Sustainable Solutions in Thane" />
          <meta
            property="og:description"
            content="Discover solar energy solutions, eco-friendly construction, and sustainable home decor with UmaSun Servikaro in Thane, Maharashtra."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://yourdomain.com" />
          <meta property="og:image" content="https://yourdomain.com/path-to-logo.png" />
        </Helmet>

        {/* Header Wrapper with Placeholder */}
        <div className="header-wrapper">
          <header className="header">
            <div className="container">
              <img src={Logo} alt="UmaSun Servikaro Logo" className="logo" loading="lazy" />
              <button
                type="button"
                className="hamburger"
                onClick={toggleNav}
                aria-label={isNavOpen ? "Close navigation menu" : "Open navigation menu"}
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
              <nav className={`nav ${isNavOpen ? 'nav-open' : ''}`}>
                <a href="#about" onClick={toggleNav}>About Us</a>
                <a href="#services" onClick={toggleNav}>Services</a>
                <a href="#clients" onClick={toggleNav}>Clients</a>
                <a href="#partners" onClick={toggleNav}>Partners</a>
                <a href="#contact" onClick={toggleNav}>Get In Touch</a>
              </nav>
            </div>
          </header>
          <div className="header-placeholder"></div>
        </div>

        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <h1>Welcome to UmaSun Servikaro</h1>
            <h2 className="hero-subtitle">INNOVATE CONSTRUCT TRANSFORM</h2>
            <p>Your Partner in Sustainable Solutions</p>
          </div>
        </section>

        {/* About Us Section */}
        <section id="about" className="section about">
          <div className="container">
            <h2>About Us</h2>
            <p>
              UmaSun Servikaro, established by <b>Shakti Sinha</b> and <b>Durgesh Kumar Dutta</b>, blends technology with sustainability through innovative solar energy solutions, eco-friendly construction, smart software development, and sustainable home decor. Our diverse team of engineers, designers, and environmental visionaries specializes in tailored solar installations for homes and businesses, green building projects using advanced materials, energy-efficient IoT software, and stylish furniture crafted from reclaimed resources. By integrating solar power, construction, and digital innovation, we provide comprehensive, tech-driven solutions that minimize carbon footprints and contribute to a greener future for all.
            </p>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="section services">
          <div className="container">
            <h2>Our Services</h2>
            <div className="services-grid">
              <div className="service-card">
                <img src={SolarSolutionsGIF} alt="Solar Solutions Animation  in Thane" className="service-gif" loading="lazy" />
                <h3>Solar Solutions</h3>
                <p>Harnessing solar energy with cutting-edge installation and maintenance services.</p>
              </div>
              <div className="service-card">
                <img src={GeneralConstructionGIF} alt="Eco-Friendly Construction Animation in Maharashtra" className="service-gif" loading="lazy" />
                <h3>General Construction</h3>
                <p>Eco-friendly building practices for sustainable and durable structures.</p>
              </div>
              <div className="service-card">
                <img src={GreenSolutionsGIF} alt="Green Solutions Animation" className="service-gif" loading="lazy" />
                <h3>Green Solutions</h3>
                <p>Environment-efficient technologies to reduce carbon footprints across India.</p>
              </div>
              <div className="service-card">
                <img src={FurnitureHomeDecorGIF} alt="Sustainable Home Decor Animation" className="service-gif" loading="lazy" />
                <h3>Furniture & Home Decor</h3>
                <p>Eco-conscious designs for modern, sustainable living spaces in India.</p>
              </div>
              <div className="service-card">
                <img src={SoftwareDevelopmentGIF} alt="IoT Software Development Animation" className="service-gif" loading="lazy" />
                <h3>Software Development</h3>
                <p>Smart IoT solutions and energy-efficient software to optimize sustainability.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Clients Section */}
        <section id="clients" className="section clients">
          <div className="container">
            <h2>Our Clients</h2>
            <div className="clients-grid">
            <div className="client-logo">
                <img src={TataLogo} alt="Tata Daewoo-TPL JV - Client of UmaSun Servikaro" className="client-logo-img" loading="lazy" />
              </div>
              <div className="client-logo">
                <img src={NeocellLogo} alt="Neocell Industries - Client of UmaSun Servikaro" className="client-logo-img" loading="lazy" />
              </div>
              <div className="client-logo">
                <img src={TriozoneLogo} alt="Triozone - Client of UmaSun Servikaro" className="client-logo-img" loading="lazy" />
              </div>
              <div className="client-logo">
                <img src={SimectiveLogo} alt="Simective Engineers Pvt. Ltd. - Client of UmaSun Servikaro" className="client-logo-img" loading="lazy" />
              </div>
              <div className="client-logo">
                <img src={ElectroAssociatesLogo} alt="Electro Associates - Client of UmaSun Servikaro" className="client-logo-img" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        {/* Partners Section */}
        <section id="partners" className="section partners">
          <div className="container">
            <h2>Our Partners</h2>
            <div className="partners-grid">
              <div className="partner-card">
                <img
                  src={Sinha}
                  alt="Shakti Sinha, CEO & Founder of UmaSun Servikaro"
                  className="partner-photo"
                  loading="lazy"
                />
                <h3>Shakti Sinha</h3>
                <p className="partner-title">CEO & Founder</p>
                <p>
                  "We pride ourselves on being a reliable and professional company that is dedicated to delivering high-quality civil, mechanical, electrical, and instrumentation services that meet the highest industry standards."
                </p>
              </div>
              <div className="partner-card">
                <img
                  src={DuttaPhoto}
                  alt="Durgesh Kumar Dutta, Co-Founder of UmaSun Servikaro"
                  className="partner-photo"
                  loading="lazy"
                />
                <h3>Durgesh Kumar Dutta</h3>
                <p className="partner-title">Co-Founder</p>
                <p>
                  "Our goal is to be a trusted partner for our clients, delivering projects on time, within budget, and to their exact specifications."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Get In Touch Section */}
        <section id="contact" className="section contact">
          <div className="container">
            <h2>Get In Touch</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
              <button type="submit" className="submit-button">Send Message</button>
            </form>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-info">
                <h4>UmaSun Servikaro</h4>
                <p>H274 Tata Housing Amantra Bhiwandi</p>
                <p>Bypass, Thane 421302 Maharashtra, India</p>
                <p><strong>LLP Identification Number:</strong> ACD-1950</p>
                <p><strong>GST:</strong> 27AAIFU0038L1ZZ</p>
                <p><strong>Phone:</strong> <a href="tel:+919167822792">+91 9167822792</a></p>
                <p><strong>Email:</strong> <a href="mailto:shaktisinha@umasunservikaro.com">shaktisinha@umasunservikaro.com</a></p>
              </div>
              <div className="footer-links">
                <a href="#about">About</a>
                <a href="#services">Services</a>
                <a href="#contact">Contact</a>
              </div>
            </div>
            <p className="footer-copyright">© Copyright UmaSun Servikaro. All Rights Reserved</p>
          </div>
        </footer>
      </div>
    </HelmetProvider>
  );
};

export default App;